import { useTranslation } from "react-i18next";

import { DOMAIN, PREVIEW_DOMAIN, SHOPIFY_DOMAIN } from "@const/urls";

import useCheckLocation from "@hooks/useCheckLocation";

import { useLayoutStore } from "@store/layout";

const MARKET = {
  ko: "KRW ₩",
  en: "USD $",
  jp: "JPY ¥",
};

const CURRENCY = { ko: "₩", jp: "￥", en: "$" };

type TLanguage = "ko" | "en" | "jp";

function useLanguage() {
  const { i18n } = useTranslation();
  const { isProduct } = useCheckLocation();

  const { closeAll } = useLayoutStore();

  const localLang: TLanguage = (localStorage.getItem("i18nextLng") as TLanguage) ?? "ko";

  const changeLanguage = (changeLang: TLanguage) => {
    const stage = localStorage.getItem("stage") ?? "local";
    const isLocal = stage === "local";
    const currentOrigin = `${window.location.origin}/`;
    const nextOrigin =
      stage === "preview" ? PREVIEW_DOMAIN[changeLang as keyof typeof PREVIEW_DOMAIN] : DOMAIN[changeLang as keyof typeof DOMAIN];

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete("variantId"); // variantID 제거
    const newPath = (currentUrl.pathname + currentUrl.search).slice(1);

    closeAll();

    if (isLocal) {
      void i18n.changeLanguage(changeLang);
      window.location.href = isProduct ? `${currentOrigin}${newPath}` : window.location.href;
      return;
    }

    window.location.href = isProduct ? `${nextOrigin}${newPath}` : window.location.href.replace(currentOrigin, nextOrigin);
  };

  return {
    changeLanguage,
    lang: localLang,
    currency: CURRENCY[localLang as keyof typeof CURRENCY],
    market: MARKET[localLang as keyof typeof MARKET],
    domain: DOMAIN[localLang as keyof typeof DOMAIN],
    shopifyDomain: SHOPIFY_DOMAIN[localLang as keyof typeof SHOPIFY_DOMAIN],
  };
}

export default useLanguage;
